import { countValue } from "./upcomingMatch";

export const squadChoice = squad => squad?.squadId ? `id:${squad.squadId}` : squad?.squadNumber != null ? `number:${squad.squadNumber}` : "";
export const squadTitle = (squad, index = 0) => squad?.label || `Squad ${squad?.squadNumber ?? index + 1}`;
export const squadPayload = squad => squad ? {
  ...(squad.squadId ? { squadId: squad.squadId } : {}),
  ...(squad.squadNumber !== null ? { squadNumber: squad.squadNumber } : {}),
  ...(squad.squadScheduledAt ? { squadScheduledAt: squad.squadScheduledAt } : {}),
} : {};

export function registrationSquads(summary, match) {
  const squads = summary?.squads?.length ? summary.squads : match?.squads || [];
  return squads.map(squad => {
    const count = countValue(squad.activeRegistrationCount);
    const capacity = countValue(squad.maxCompetitorCount);
    const remaining = countValue(squad.remainingCapacity) ?? (count !== null && capacity !== null ? Math.max(0, capacity - count) : null);
    return { squadId: String(squad.squadId || ""), squadNumber: countValue(squad.squadNumber ?? squad.number), label: squad.label,
      squadScheduledAt: squad.squadScheduledAt || squad.scheduledAt || squad.matchTime,
      count, capacity, remaining, isFull: squad.isFull === true || remaining === 0 };
  }).filter(squad => squadChoice(squad)).sort((a, b) => (a.squadNumber ?? Infinity) - (b.squadNumber ?? Infinity));
}

export function currentSquadChoice(registration, squads) {
  if (!registration || !["pending", "confirmed"].includes(String(registration.status).toLowerCase())) return "";
  const squad = squads.find(item => registration.squadId && item.squadId === registration.squadId)
    || squads.find(item => countValue(registration.squadNumber) !== null && item.squadNumber === countValue(registration.squadNumber));
  return squadChoice(squad);
}
